import { OptimizeRoute, MyDayOfWeek } from '@app/@core/enums';
import moment from 'moment';

export class CreateRouteModel {
  id: number;
  name: string;
  vehicleId: number;
  userTenantId: number;
  routeDay: MyDayOfWeek;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  startPointAddress1: string;
  startPointAddress2: string;
  startPointCity: string;
  startPointState: string;
  startPointZipCode: string;
  startPointCountry: string;
  startPointLongitude: number;
  startPointLatitude: number;
  optimizeRoute: OptimizeRoute;
  selectedDate: moment.Moment | null;
  isApplOnThisWeek: boolean;
}

export function getRouteStartDate(selectedDate: moment.Moment) {
  return selectedDate.isBefore(moment(), 'day') ?
    moment() : selectedDate;
}
